import IndividualAccountForm from './IndividualAccountForm'

export default IndividualAccountForm
